/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DistributedMaterialsRequest } from '../models/DistributedMaterialsRequest';
import type { DistributedMaterialsResponse } from '../models/DistributedMaterialsResponse';
import type { Employee } from '../models/Employee';
import type { EmployeeMaterialStatusResponse } from '../models/EmployeeMaterialStatusResponse';
import type { EmployeeResponse } from '../models/EmployeeResponse';
import type { WorkDay } from '../models/WorkDay';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmployeeService {
    /**
     * @param employeeId The id of the employee to update the distributed schedule for
     * @param scheduleId The id of the schedule to update the distributed schedule for
     * @param requestBody
     * @returns DistributedMaterialsResponse Update the distributed schedule for the employee with the specified id and schedule id
     * @throws ApiError
     */
    public static postEmployeeScheduleDistributed(
        employeeId: number,
        scheduleId: number,
        requestBody: DistributedMaterialsRequest,
    ): CancelablePromise<DistributedMaterialsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employee/{employeeId}/schedule/{scheduleId}/distributed',
            path: {
                'employeeId': employeeId,
                'scheduleId': scheduleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `No employee or schedule found with the specified ids`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to retrieve the distributed schedule for
     * @param scheduleId The id of the schedule to retrieve the distributed schedule for
     * @returns DistributedMaterialsResponse The distributed schedule for the employee with the specified id and schedule id
     * @throws ApiError
     */
    public static getEmployeeScheduleDistributed(
        employeeId: number,
        scheduleId: number,
    ): CancelablePromise<DistributedMaterialsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/{employeeId}/schedule/{scheduleId}/distributed',
            path: {
                'employeeId': employeeId,
                'scheduleId': scheduleId,
            },
            errors: {
                404: `No employee or schedule found with the specified ids`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to update the schedule for
     * @param requestBody
     * @returns WorkDay Update the schedule for the employee with the specified id
     * @throws ApiError
     */
    public static postEmployeeSchedule(
        employeeId: number,
        requestBody: WorkDay,
    ): CancelablePromise<WorkDay> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employee/{employeeId}/schedule',
            path: {
                'employeeId': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `No employee found with the specified id`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to retrieve the schedule for
     * @param date The date to retrieve the schedule for (if not provided, the schedule for the current week will be retrieved)
     * @returns any The schedule for the employee with the specified id
     * @throws ApiError
     */
    public static getEmployeeSchedule(
        employeeId: number,
        date: string,
    ): CancelablePromise<WorkDay | null> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/{employeeId}/schedule',
            path: {
                'employeeId': employeeId,
            },
            query: {
                'date': date,
            },
            errors: {
                404: `No employee found with the specified id`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to retrieve the material status for
     * @returns EmployeeMaterialStatusResponse The material status for the employee with the specified id
     * @throws ApiError
     */
    public static getEmployeeMaterialStatus(
        employeeId: number,
    ): CancelablePromise<EmployeeMaterialStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/{employeeId}/material-status',
            path: {
                'employeeId': employeeId,
            },
            errors: {
                404: `No employee found with the specified id`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to retrieve
     * @returns Employee The employee with the specified id
     * @throws ApiError
     */
    public static getEmployeeById(
        employeeId: number,
    ): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            errors: {
                404: `No employee found with the specified id`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to update
     * @param requestBody
     * @returns Employee Update an existing employee
     * @throws ApiError
     */
    public static putEmployee(
        employeeId: number,
        requestBody: Employee,
    ): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/employee/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `No employee found with the specified id`,
            },
        });
    }
    /**
     * @param employeeId The id of the employee to delete
     * @returns void
     * @throws ApiError
     */
    public static deleteEmployee(
        employeeId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/employee/{employeeId}',
            path: {
                'employeeId': employeeId,
            },
            errors: {
                404: `No employee found with the specified id`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns Employee Add a new employee
     * @throws ApiError
     */
    public static postEmployee(
        requestBody: Employee,
    ): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/employee',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param query Filter employees by text in their first, last name or coordinator
     * @param dateOfBirth Filter employees by their date of birth
     * @returns EmployeeResponse The currently available employees
     * @throws ApiError
     */
    public static getEmployees(
        query?: string,
        dateOfBirth?: string,
    ): CancelablePromise<EmployeeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employee',
            query: {
                'query': query,
                'dateOfBirth': dateOfBirth,
            },
        });
    }
}
